import { Button, Drawer, Typography } from "antd";
import {
  PhoneOutlined,
  FileTextOutlined,
  LoginOutlined,
  LogoutOutlined,
  UserOutlined,
  LockOutlined,
  AppstoreAddOutlined,
  PlayCircleOutlined
} from "@ant-design/icons";

const { Title } = Typography;

export default function Sidebar({
  isLoggedIn,
  setShowAuthModal,
  showSidebar,
  setShowSidebar,
  setShowUpdateProfileModal,
  logOut,
  setContactUsVisible,
  setFaqVisible
}) {
  return (
    <Drawer
      title={<Title level={4} style={{ fontWeight: "bold", margin: 0 }}>
        Menu
      </Title>}
      placement="right"
      closable={false}
      onClose={() => setShowSidebar(false)}
      visible={showSidebar}
      width={220}
    >
      <div style={{  }}>
        {!isLoggedIn ? (
          <Button
            type="text"
            style={{
              fontSize: "18px",
              padding: "20px 16px",
              textAlign: "left",
            }}
            onClick={() => {
              setShowAuthModal(true);
              setShowSidebar(false);
            }}
          >
            <LoginOutlined style={{ fontSize: "18px", marginRight: "8px" }} />{" "}
            Login/Signup
          </Button>
        ) : null}
        <Button
          type="text"
          style={{ fontSize: "18px", padding: "20px 16px", textAlign: "left" }}
          onClick={() => {setContactUsVisible(true); setShowSidebar(false)}}
        >
          <PhoneOutlined style={{ fontSize: "18px", marginRight: "8px" }}  /> Contact Us
        </Button>
        <Button 
          type="text" 
          style={{ fontSize: "18px", padding: "20px 16px", textAlign: "left" }} 
          onClick={() => {setFaqVisible(true); setShowSidebar(false)}}
        >
          <FileTextOutlined style={{ fontSize: "18px", marginRight: "8px" }} /> FAQs
        </Button>
        {/* Privacy Policy button that opens in new tab */}
        <Button 
          type="text" 
          style={{ fontSize: "18px", padding: "20px 16px", textAlign: "left" }}
          onClick={() => {
            window.location.href = '/#/privacyPolicy';
            setShowSidebar(false);
          }}
        >
          <LockOutlined style={{ fontSize: "18px", marginRight: "8px" }} /> Privacy Policy
        </Button>
        <Button 
          type="text" 
          style={{ fontSize: "18px", padding: "20px 16px", textAlign: "left" }}
          onClick={() => {
            window.open("https://play.google.com/store/apps/details?id=com.queueAppManagement.myapp", "_blank"); // Open in new tab
            setShowSidebar(false);
          }}
        >
          <AppstoreAddOutlined style={{ fontSize: "18px", marginRight: "8px" }} /> Update App
        </Button>
        <Button 
          type="text" 
          style={{ fontSize: "18px", padding: "20px 16px", textAlign: "left" }}
          onClick={() => {
            window.location.href = '/games/index.html';
            setShowSidebar(false);
          }}
        >
          <PlayCircleOutlined style={{ fontSize: "18px", marginRight: "8px" }} /> Games
        </Button>
        {isLoggedIn ? (
          <>
            <Button
              type="text"
              style={{ fontSize: "18px", padding: "20px 16px", textAlign: "left" }}
              onClick={() => {
                setShowUpdateProfileModal(true);
                setShowSidebar(false);
              }}
            >
              <UserOutlined style={{ fontSize: "18px", marginRight: "8px" }} /> Update Profile
            </Button>
            <Button 
              type="text" 
              style={{ fontSize: "18px", padding: "20px 16px", textAlign: "left" }} 
              onClick={logOut}
            >
              <LogoutOutlined style={{ fontSize: "18px", marginRight: "8px" }}  /> Logout
            </Button>
          </>
        ) : null}
      </div>
    </Drawer>
  );
}